import Content from "uxp-documentation/src/pages/uxp/reference-spectrum/User Interface/sp-textarea";
import * as React from 'react';
export default {
  Content,
  React
};